import {unregister} from './utils/service-worker';

import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {LocaleProvider} from 'antd';
import enUS from 'antd/lib/locale-provider/en_US';
import 'antd/dist/antd.css';
import './index.css';

import App from './App';
import store from './store/store';

ReactDOM.render(
  <LocaleProvider locale={enUS}>
    <Provider store={store}>
      <App/>
    </Provider>
  </LocaleProvider>,
  document.getElementById('root')
);

unregister();


// WEBPACK FOOTER //
// ./src/index.js